import { useState, useCallback } from "react";
import { BroadcastSupplier } from "../utils/broadcastUtils";

export function useBroadcastSuppliers() {
  const [broadcastSuppliers, setBroadcastSuppliers] = useState<
    BroadcastSupplier[]
  >([]);

  const addSupplierToBroadcast = useCallback((supplier: any) => {
    const newBroadcastSupplier: BroadcastSupplier = {
      supplierId: supplier._id,
      supplierName: supplier.businessName || supplier.name,
      mobileNumber: supplier.user?.mobileNumber || "",
    };

    setBroadcastSuppliers((prev) => {
      if (prev.some((s) => s.supplierId === newBroadcastSupplier.supplierId)) {
        return prev;
      }
      return [...prev, newBroadcastSupplier];
    });
  }, []);

  const removeSupplierFromBroadcast = useCallback((supplierId: string) => {
    setBroadcastSuppliers((prev) =>
      prev.filter((supplier) => supplier.supplierId !== supplierId),
    );
  }, []);

  const clearBroadcastSuppliers = useCallback(() => {
    setBroadcastSuppliers([]);
  }, []);

  const isSupplierInBroadcastList = useCallback(
    (supplierId: string): boolean => {
      return broadcastSuppliers.some(
        (supplier) => supplier.supplierId === supplierId,
      );
    },
    [broadcastSuppliers],
  );

  return {
    broadcastSuppliers,
    addSupplierToBroadcast,
    removeSupplierFromBroadcast,
    clearBroadcastSuppliers,
    isSupplierInBroadcastList,
  };
}
